module.exports = __webpack_public_path__ + "static/assets/babaffcbf18924e42abcd841cfe05724.png";